module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAMCAYAAAAK/x/DAAAAAXNSR0IArs4c6QAAAL5JREFUOE/F1L0KwjAYheFz3NwNFK/Ljs6CBfFSpFDB2bFelxTq7uaRCIEWDU1qfzJ1aMrLw/eVyUkpiUKCwYyHRC0ho21IchkKZwmbOZpI3ETsqwPrT5A7U2s5lerI0jW0gqbUaqo0Ub6Cxtb6pRIUNIaWTyU4aCitLpXoIKeFFwoAaeQmllggsxsUcs87Q77LoZsYo9JLqPV7yGU6tKJU/g7yzVZflcGC7IfWF630xNY+c4nrfcdHyKz43nkD9zxtCQ09GZgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/trigon.png
// module id = aWKz
// module chunks = 96